import React, { Fragment } from 'react';

import { useCurrentCheckoutStep } from 'pages/checkout-v3/hooks/checkoutStepHooks';

import { ProgressMarker } from './components/ProgressMarker';
import { Divider, ProgressContainer, ProgressWrapper } from './Progress-styled-components';

export const addStepDividers = (elements: React.ReactNode[], currentStepIndex: number) =>
  elements.reduce((acc: React.ReactNode[], element, index) => {
    if (index === 0) {
      return [...acc, element];
    }

    const divider = <Divider key={`separator-${index}`} $isActive={index <= currentStepIndex} />;
    return [...acc, divider, element];
  }, [] as React.ReactNode[]);

export const Progress = () => {
  const { currentStepIndex, applicableStepDefinitions } = useCurrentCheckoutStep();

  const visibleSteps = applicableStepDefinitions.filter((stepDefinition) => stepDefinition.showInProgress);

  const steps = applicableStepDefinitions.map((stepDefinition, index) => {
    const isVisible = visibleSteps.includes(stepDefinition);
    if (!isVisible) {
      return null;
    }

    const stepNumber = visibleSteps.indexOf(stepDefinition) + 1;

    return (
      <Fragment key={stepDefinition.id}>
        <ProgressMarker
          stepName={stepDefinition.name}
          stepNumber={stepNumber}
          isHighlighted={index <= currentStepIndex}
        />
      </Fragment>
    );
  }).filter(Boolean);

  return (
    <ProgressWrapper>
      <ProgressContainer>
        {addStepDividers(steps, currentStepIndex)}
      </ProgressContainer>
    </ProgressWrapper>
  );
};
